import React from 'react'

import { Button } from '@insquad/tools'

import { Input } from 'src/common/components/_form/Input/Input'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import s from './IntroBlockHeaderForm.module.scss'

export type IntroBlockHeaderFormProps = {
  name: string
}

export const IntroBlockHeaderForm: React.FC<IntroBlockHeaderFormProps> = ({
  name,
}) => {
  const { analytic } = useAnalytic()
  const { handleSubmitHireNow } = useAuthRedirect()

  const handleSignUp = (e: React.FormEvent<HTMLFormElement>) => {
    analytic.event(AnalyticEventEnum.SIGN_UP, {
      page: 'domain or skill',
      from: 'input-top',
    })

    handleSubmitHireNow(e)
  }

  return (
    <div className={s.IntroBlockHeaderForm}>
      <Typography
        className={s.IntroBlockHeaderForm__title}
        variant={EnumTypographyVariants.H2}
        as="h1"
      >
        {'Hire Startup ready '}
        <span>{name}</span>
        <br />
        {' developer in one click'}
      </Typography>

      <Typography
        className={s.IntroBlockHeaderForm__description}
        variant={EnumTypographyVariants.H7}
        as="p"
      >
        Sign up to get access to a pool of remote senior developers. Every
        talent is ready to join your team in 1-2 weeks
      </Typography>

      <form onSubmit={handleSignUp} className={s.IntroBlockHeaderForm__form}>
        <Input
          placeholder="Enter your e-mail"
          containerProps={{ className: s.IntroBlockHeaderForm__input }}
        />
        <Button type="submit" className={s.IntroBlockHeaderForm__btn}>
          Hire now
        </Button>
      </form>
    </div>
  )
}
